import React from 'react';
import { TraditionalStores } from '../../common';

/** Map filters (canal / cliente / segmentación), selected marker and storecheck-recency counts. */
export function useStoresMap({ stores, visitedStoreIds = [] }) {
    const [selectedStore, setSelectedStore] = React.useState(null);
    const [filteredStores, setFilteredStores] = React.useState([]);
    const [channel, setChannel] = React.useState('both');
    const [client, setClient] = React.useState('both');
    const [storeType, setStoreType] = React.useState('both');
    const [mapCenter, setMapCenter] = React.useState({ lat: 10.5, lng: -66.9 });

    const visitedSet = React.useMemo(() => new Set(visitedStoreIds.map(String)), [visitedStoreIds]);

    React.useEffect(() => {
        let filtered = stores?.filter((store) => store?.coordinates?.latitude && store?.coordinates?.longitude);

        if (channel !== 'both') {
            const formattedChannel = channel === 'moderno' ? 'MODERNO' : 'TRADICIONAL';
            filtered = filtered.filter((store) => store.channel === formattedChannel);
        }

        if (storeType !== 'both') {
            filtered = filtered.filter((store) => store.storeType === storeType);
        }

        if (client !== 'both') {
            filtered = filtered.filter((store) => store.clientName === client);
        }

        setFilteredStores(filtered);
    }, [stores, channel, storeType, client]);

    const handleMarkerClick = (store) => {
        setSelectedStore(store);
        setMapCenter({
            lat: store?.coordinates?.latitude,
            lng: store?.coordinates?.longitude
        });
    };

    const storeTypes = TraditionalStores?.map((store) => ({ value: store?.value, label: store?.label }));

    const isVisited = (store) => visitedSet.has(String(store?._id));
    const greenCount = filteredStores.filter((s) => isVisited(s)).length;
    const redCount = filteredStores.length - greenCount;

    return {
        selectedStore,
        filteredStores,
        channel,
        setChannel,
        setClient,
        setStoreType,
        mapCenter,
        handleMarkerClick,
        storeTypes,
        isVisited,
        greenCount,
        redCount
    };
}
